export enum StoreName {
  Session = 'session',
}
